'use strict';

var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _inherits = require('@babel/runtime/helpers/inherits');
var _possibleConstructorReturn = require('@babel/runtime/helpers/possibleConstructorReturn');
var _getPrototypeOf = require('@babel/runtime/helpers/getPrototypeOf');
var _wrapNativeSuper = require('@babel/runtime/helpers/wrapNativeSuper');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultCompat(_classCallCheck);
var _inherits__default = /*#__PURE__*/_interopDefaultCompat(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultCompat(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultCompat(_getPrototypeOf);
var _wrapNativeSuper__default = /*#__PURE__*/_interopDefaultCompat(_wrapNativeSuper);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

/**
 * InvalidParameterError class.
 *
 * @class
 * @augments Error
 * @example
 * throw new InvalidParameterError('<YOUR_MESSAGE_HERE>');
 */
var InvalidParameterError = /*#__PURE__*/function (_Error) {
  _inherits__default["default"](InvalidParameterError, _Error);

  var _super = _createSuper(InvalidParameterError);

  function InvalidParameterError(message) {
    var _this;

    _classCallCheck__default["default"](this, InvalidParameterError);

    _this = _super.call(this, message);
    _this.name = 'InvalidParameterError';
    return _this;
  }

  return InvalidParameterError;
}( /*#__PURE__*/_wrapNativeSuper__default["default"](Error));

InvalidParameterError.HELPER_ID = 'Gearz.JsUtils.InvalidParameterError';

module.exports = InvalidParameterError;
